import type {
  AdvancedSearchQuery,
  FieldOperator,
  LogicalOperator,
} from '../../components/TableSearch/types';

/**
 * A named filter preset for the products DataGrid.
 * Built-in presets are locked (not editable or deletable by users).
 * User-saved presets are stored in localStorage under STORAGE_KEY_FILTER_PRESETS.
 */
export interface FilterPreset {
  name: string;
  query: AdvancedSearchQuery;
  isBuiltIn: boolean;
}

/**
 * Code-embedded built-in filter presets.
 * These are never written to localStorage — defined here as constants.
 *
 * Order matters: first entry is applied on first load when no localStorage preference exists.
 */
export const BUILT_IN_FILTER_PRESETS: FilterPreset[] = [
  {
    name: 'Orange Book Active',
    isBuiltIn: true,
    query: {
      filterGroups: [
        {
          id: 'preset-fda-active',
          logicalOperator: 'AND' as LogicalOperator,
          rules: [
            {
              id: 'rule-fda-active-1',
              field: 'is_fda_linked',
              operator: 'equals' as FieldOperator,
              // String 'true' — backend handles both boolean true and string 'true'
              // (see advancedSearchBuilder.js addRuleParameter boolean branch)
              value: 'true',
            },
            {
              id: 'rule-fda-active-2',
              field: 'grade_name',
              operator: 'notEquals' as FieldOperator,
              value: 'Intermediate',
            },
            {
              id: 'rule-fda-active-3',
              field: 'grade_name',
              operator: 'notEquals' as FieldOperator,
              value: 'Intermediates',
            },
          ],
        },
      ],
      groupOperator: 'AND' as LogicalOperator,
    },
  },
  {
    name: 'All Products',
    isBuiltIn: true,
    // Empty filterGroups = no filter applied (show all products)
    query: {
      filterGroups: [],
      groupOperator: 'AND' as LogicalOperator,
    },
  },
];
